module.exports = __webpack_public_path__ + "img/location-red.e624a567.svg";